import { type HestiaIframeTarget } from './hestiaIframeEvents'

interface RegisteredHestiaIframe {
  origin: string
  window: Window
}

interface RegisterHestiaIframeParams {
  origin: string
  target: HestiaIframeTarget
  window: Window
}

interface PostMessageToHestiaIframeTargetParams {
  excludeWindow?: Window
  message: object
  target: HestiaIframeTarget
}

const registeredHestiaIframes = new Map<
  HestiaIframeTarget,
  RegisteredHestiaIframe
>()

export const registerHestiaIframe = ({
  origin,
  target,
  window,
}: RegisterHestiaIframeParams): void => {
  registeredHestiaIframes.set(target, {
    origin,
    window,
  })
}

export const unregisterHestiaIframe = (
  window: Window | null | undefined
): void => {
  if (!window) return

  registeredHestiaIframes.forEach((iframe, target) => {
    if (iframe.window === window) {
      registeredHestiaIframes.delete(target)
    }
  })
}

export const postMessageToHestiaIframeTarget = ({
  excludeWindow,
  message,
  target,
}: PostMessageToHestiaIframeTargetParams): void => {
  const iframe = registeredHestiaIframes.get(target)
  if (!iframe || iframe.window === excludeWindow) return

  iframe.window.postMessage(message, iframe.origin)
}

export const clearHestiaIframeRegistryForTests = (): void => {
  registeredHestiaIframes.clear()
}
